<template>
    <div class="row well">
        <div v-for="col in columns" class="col-md-3" :key="col.index">
            <ul type="none" style="padding-left:0px">
                <li v-for="field in splits[col]" :key="field.index">
                    <div class="checkbox checkbox-inline">
                        <input type="checkbox" :disabled="readonly" v-model="selectedList" v-bind:id="name + field[fieldName] + suffix" v-bind:value="field[fieldName]">
                            <label v-bind:for="name + field[fieldName] + suffix">{{ field.description }}</label>
                    </div>
                </li>
            </ul>
        </div>
        <div v-if="isDebug">
            {{selectedList}}
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'

export default {
    name: 'checkBoxPanel',
    props: {
        numColumns: {},
        lookupList: {},
        fieldName: {},
        name: {},
        suffix: { default: '' },
        readonly: { default: false }
    },
    computed: {
        columns: function () {
            var arr = []
            for (var i = 0; i < this.numColumns; i++) {
                arr.push(i)
            }
            loggingService.log(this.isDebug, 'Check Box Panel', `array size: ${arr.length}`)
            return arr
        },
        splits: function () {
            var splits = []
            var chunkSize = Math.ceil(this.lookupList.length / this.numColumns)
            loggingService.log(this.isDebug, 'Check Box Panel', `Splitting. ChunkSize: ${chunkSize}, fieldLength: ${this.lookupList.length} , ${this.numColumns}`)
            for (var i = 0; i < this.lookupList.length; i += chunkSize) {
                splits.push(this.lookupList.slice(i, i + chunkSize))
            }
            loggingService.log(this.isDebug, 'Check Box Panel', `Splitting. ChunkSize: ${chunkSize} splits length ${splits.length} FirstSplit: ${splits[0]}`)
            return splits
        }
    },
    data: function () {
        return {
            isDebug: false,
            selectedList: []
        }
    }
}
</script>



// WEBPACK FOOTER //
// CheckBoxPanel.vue?4b9b1c84